export default [{
  name: 'onboarding',
  namespaced: true,
  state: {
    model: {
      Pessoa: {
        TipoPessoa: null,
        TipoConta: null,
        pf: {},
        pj: {},
        endereco: {}
      },
      Controlador: {
        endereco: {},
        pj: {}
      },
      Credor: {
        nome: null,
        documentoFederal: null,
        tipoOperacao: null,
        codigoPessoaDado: null,
        informacaoAdicional: null,
      },
      dadosPreenchedor: {},
      Operadores: [],
      Socio: {
        endereco: {},
        pf: {}
      },
      Socios: []
    },
    tipoFluxo: {
      TipoPessoa: null,
      TipoConta: null,
      TipoCadastro: null
    },
    isHomeLoaded: false,
    isLoginToken: false,
    isFluxoContinuacao: false,
    listaSubparceiros: [],
    subparceiro: null,
    showModal: false,
    textModal: '',
    textModalPersonalizado: '',
    titleModal: '',
    backToHome: null,
    modalBloqueado: null,
    paramNovoIb: null
  },
  mutations: {
    model (state, obj) {
      state.model = obj
    },
    tipoFluxo (state, obj) {
      state.tipoFluxo = obj
    },
    homeLoaded (state, isHomeLoaded) {
      state.isHomeLoaded = isHomeLoaded
    },
    setListaSubparceiros (state, listaSubparceiros) {
      state.listaSubparceiros = listaSubparceiros
    },
    setSubparceiro (state, subparceiro) {
      state.subparceiro = subparceiro
    },
    loginToken (state, isLoginToken) {
      state.isLoginToken = isLoginToken
    },
    openModal (state, { text, title, backToHome, modalBloqueado }) {
      state.showModal = true
      state.textModal = text
      state.titleModal = title
      state.backToHome = backToHome
      state.modalBloqueado = modalBloqueado
    },
    closeModal (state) {
      state.showModal = false
      state.textModal = ''
      state.titleModal = ''
    },
    setParamNovoIb (state, value) {
      state.paramNovoIb = value;
    },
    setFluxoContinuacao (state, value) {
      state.isFluxoContinuacao = value;
    }
  },
  getters: {
    model (state) {
      return state.model
    },
    tipoFluxo (state) {
      return state.tipoFluxo
    },
    homeLoaded (state) {
      return state.isHomeLoaded
    },
    listaSubparceiros (state) {
      return state.listaSubparceiros
    },
    subparceiro (state) {
      return state.subparceiro
    },
    loginToken (state) {
      return state.isLoginToken
    },
    paramNovoIb (state) {
      return state.paramNovoIb;
    },
    isFluxoContinuacao (state) {
      return state.isFluxoContinuacao;
    }
  },
  actions: {
    clearModel ({ commit }) {
      const data = {
        Pessoa: {
          TipoPessoa: null,
          TipoConta: null,
          pf: {},
          pj: {},
          endereco: {}
        },
        Controlador: {
          endereco: {},
          pj: {}
        },
        Credor: {
          nome: null,
          documentoFederal: null,
          tipoOperacao: null,
          codigoPessoaDado: null,
          informacaoAdicional: null,
        },
        dadosPreenchedor: {},
        Operadores: [],
        Socio: {
          endereco: {},
          pf: {}
        },
        Socios: []
      }
      const tipoFluxo = {
        TipoPessoa: null,
        TipoConta: null,
        TipoCadastro: null
      }
      commit('model', data)
      commit('tipoFluxo', tipoFluxo)
      commit('homeLoaded', false)
      commit('loginToken', false)
    },
    openModal ({ commit }, data) {
      commit('openModal', data)
    },
    beforeEach ({ getters, commit }, { to, from, next }) {
      if (localStorage.isLoginToken) {
        next()
      } else {
        switch (to.fullPath) {
          case '/':
            if (localStorage.ambiente) { next({ path: '/partner/' + localStorage.ambiente }) }
            break;
        }
      }
    },
  },
  logoutFunctions: {
    afterClear (state) {
      location.href = '/partner/' + state.empresa.ambiente
    },
  }
}]
